<template>
  <app-checkbox v-model="value"
                class="epoch-selector-item"
                :disabled="isDisabled"
  >
    <span class="epoch-selector-item__period">{{ epoch.name }}</span>
    <span class="epoch-selector-item__images-count">{{ $t('header.filters.epoch.itemsCount', { count: epoch.imagesCount }) }}</span>
  </app-checkbox>
</template>

<script>
import filterMixin from "@/mixins/filter";
import AppCheckbox from "@/components/common/AppCheckbox/AppCheckbox";

export default {
  name: "EpochSelectorItem",
  mixins: [filterMixin],
  components: {
    AppCheckbox
  },
  computed: {
    epoch() {
      return this.filter
    },
    isDisabled() {
      return this.epoch.imagesCount === 0
    }
  }
}
</script>

<style lang="scss">
.epoch-selector-item {
  white-space: nowrap;

  &__period {
    color: $app-primary-color;
    font-size: 1.1em;
  }

  &__images-count {
    font-weight: 400;
    margin-left: 10px;
  }
}
</style>